import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';

const useSurvey = ({ surveyId, extraFields } = {}) => {
  const query = gql`
    query UseSurvey($surveyId: ID!) {
      survey(id: $surveyId) {
        id
        title
        ${extraFields || ''}
      }
    }
  `;

  const { data: { survey } = {}, ...rest } = useQuery(query, {
    variables: { surveyId },
    skip: !surveyId,
  });

  return {
    survey,
    ...rest,
  };
};

export default useSurvey;
